import React from 'react'
import styles from './InvoiceDetails.module.scss'
import Layout from '../../components/core/Layout';
import { useParams } from 'react-router-dom';
import { getTaxRate, postInvoiceContent } from '../../apis/invoice-api';
import { INVOICE_TAB_INDEX, InvStatus } from '../../libs/constants';
import { InvoiceDetailsResponseData, InvoiceMasterData } from "../../apis/models/InvoiceMasterRequest";
import { error, success } from '../../apis/reducers/snackbarsReducer';
import { useDispatch, useSelector } from 'react-redux';
import { getInvoiceDetails, getInvoiceMaster, putInvoiceMaster } from '../../apis/invmaster-api';
import { TaxResponseData } from '../../apis/models/TaxResponse';
import InvoiceHeader from '../../components/InvoiceDetailsPage/header/InvoiceHeader';
import InvoiceContent, { InvoiceContentTabType } from '../../components/InvoiceDetailsPage/InvoiceContent/InvoiceContent';
import { RootState } from '../../apis/store';
import { saveMasterInfo } from '../../apis/reducers/invoiceMasterReducer';

const InvoiceContentPage = () => {
  const invoiceMasterState = useSelector((state: RootState) => state.invoiceMaster);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [invoiceMasterData, setInvoiceMasterData] = React.useState<InvoiceMasterData | null>(invoiceMasterState.masterData);
  const [taxItem, setTaxItem] = React.useState<TaxResponseData | null>(null);
  const [invoiceDetails, setInvoiceDetails] = React.useState<InvoiceContentTabType[]>([]);
  const [notYetSaved, setNotYetSaved] = React.useState<boolean>(false);
  const [isChanged, setIsChanged] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (id) {
      loadAllData();
    }
  },[id])

  const hasError = React.useMemo(() => {
    return invoiceDetails.some(fee => {
      return fee.error.name || fee.error.quantity || fee.error.unitPrice
    })
  },[invoiceDetails]);

  const loadAllData = () => {
    getInvoiceMasterData();
    loadInvoiceDetailsData();
    setNotYetSaved(false);
  }

  const onSaveAndCommit = async () => {
    const isSuccess = await saveData();
    if (isSuccess){
      onChangeInvoiceStatus(InvStatus.CONFIRMED)
    }
  }

  const onChangeInvoiceStatus = async (status: InvStatus) => {
    try {
      await putInvoiceMaster(id!, {status: status})
      dispatch(success("請求ステータスを変更しました"));
      loadAllData();
    }catch (err) {
      dispatch(error("請求ステータスの変更に失敗しました"));
    }
  }

  const getInvoiceMasterData = () => {
    getInvoiceMaster(id)
    .then(function (response) {
        setInvoiceMasterData(response.data.data);
        dispatch(saveMasterInfo({masterData: response.data.data}))
        getTaxRate(new Date(response.data.data.from).toString())
          .then(res => setTaxItem(res.data.data))
          .catch(err => console.log(err))
    })
    .catch(function (error) {
        console.log(error);
    })
  }

  const loadInvoiceDetailsData = () => {
    getInvoiceDetails(id)
      .then(function (response) {
        const data: InvoiceContentTabType[] = []
        response.data.data.forEach((item: InvoiceDetailsResponseData) => {
          const dataItem: InvoiceContentTabType = {
            invoiceMasterId: item.invoiceMasterId,
            name: item.name,
            totalPrice: item.totalPrice,
            description: item.description,
            id: item.invoiceContentId,
            nameAlias: item.nameAlias,
            quantity: item.quantity,
            unitPrice: item.unitPrice,
            order: item.order,
            error: {}
          }
          data.push(dataItem);
        })
        setInvoiceDetails(data);
      })
      .catch(function (error) {
          console.log(error);
          dispatch(error("データ取得でエラーが発生しました"))
      })
  }

  const onChangeFees = (items: InvoiceContentTabType[]) => {
    setInvoiceDetails(items);
    setNotYetSaved(true);
  }

  const saveData = async () => {
    if (!id) {
      return false;
    }
    invoiceDetails.forEach((item, index) => {
      item.invoiceMasterId = id;
      item.order = index + 1;
    })
    try {
      await postInvoiceContent(id, invoiceDetails);
      dispatch(success("保存しました"));
      loadAllData();

      return true;
    } catch (e) {
      dispatch(error("保存に失敗しました"))
    }
    return false;
  }

  return (
    <Layout withBreadcrumbs={true} bgColor="#FAFAFA">
      <React.Fragment>
        <div className={styles.Gray}>
          <div>
            <InvoiceHeader
              invoiceMaster={invoiceMasterData ?? undefined}
              invoiceDetails={invoiceDetails ?? undefined}
              tax={taxItem ?? undefined}
              selectedTab={INVOICE_TAB_INDEX.CONTENT}
              needSave={notYetSaved}
              error={hasError}
              onSaveAndCommit={() => onSaveAndCommit()}
              onChangeStatus={(status) => onChangeInvoiceStatus(status)}
              onMasterChange={() => loadAllData()}
            />
          </div>
          <div className={styles.tabs}>
            <div className={styles.tabs__body}>
              {invoiceMasterData &&
                <InvoiceContent
                  targetInvoice={invoiceMasterData}
                  tabValues={invoiceDetails}
                  taxRate={taxItem ? taxItem.taxPercent : 10}
                  isChanged={isChanged}
                  onNotYetConfirmed={() => onChangeInvoiceStatus(InvStatus.NOT_CONFIRMED)}
                  onReset={() => loadAllData()}
                  onSave={() => saveData()}
                  onChange={(items) => {onChangeFees(items); setIsChanged(true)}}
                />
              }
            </div>
          </div>
        </div>
      </React.Fragment>
    </Layout>
  )
}

export default InvoiceContentPage